export const getFromBucket = (bucket: string | undefined, key: string | null | undefined, region: string): string | undefined =>
  bucket && key ? `https://${bucket}.s3.${region}.amazonaws.com/${encodeURIComponent(key)}` : undefined;

export const getPublicImageUrl = (
  key: string | null | undefined,
  region = process.env.NEXT_PUBLIC_S3_BUCKET_REGION ?? 'eu-west-1',
): string | undefined => getFromBucket(process.env.NEXT_PUBLIC_S3_BUCKET, key, region);
